import React from "react";

const LamaForm = ({ formData, handleChange }) => {
    return (
        <>
            <div className="p-3" style={{ maxHeight: "65vh", overflowY: "auto", scrollbarWidth: "thin" }}>
                <div className="accordion" id="lamaAccordion">
                    {/* Patient Details */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#patientDetails">
                                Patient Details
                            </button>
                        </h2>
                        <div id="patientDetails" className="accordion-collapse collapse show">
                            <div className="accordion-body pt-3">
                                <div className="row g-3">
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="patientName"
                                                value={formData.patientName || ""}
                                                onChange={handleChange}
                                                readOnly={!!formData.patientId} // ⭐ ADD THIS PROPERTY TO LOCK INPUT BOX ⭐
                                            />
                                            <label>Patient Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="guardianName" value={formData.guardianName || ""} onChange={handleChange} />
                                            <label>Guardian Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="relationWithPatient" value={formData.relationWithPatient || ""} onChange={handleChange} />
                                            <label>Relation with Patient</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="guardianCnic" value={formData.guardianCnic || ""} onChange={handleChange} />
                                            <label>CNIC of Guardian</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Staff Details */}
                    <div className="accordion-item mb-3 shadow-sm rounded">
                        <h2 className="accordion-header">
                            <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#staffDetails">
                                Staff Details (To be filled by Staff)
                            </button>
                        </h2>
                        <div id="staffDetails" className="accordion-collapse collapse">
                            <div className="accordion-body pt-3">
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                                    Reason for LAMA
                                </small>
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="reasonForLama" id="financialConstraints" value="Financial Constraints" checked={formData.reasonForLama === "Financial Constraints"} onChange={handleChange} />
                                            <label className="form-check-label" htmlFor="financialConstraints">Financial Constraints</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="reasonForLama" id="familyConcerns" value="Family Concerns" checked={formData.reasonForLama === "Family Concerns"} onChange={handleChange} />
                                            <label className="form-check-label" htmlFor="familyConcerns">Family Concerns</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="reasonForLama" id="dissatisfiedPatientCare" value="Dissatisfied with Patient Care" checked={formData.reasonForLama === "Dissatisfied with Patient Care"} onChange={handleChange} />
                                            <label className="form-check-label" htmlFor="dissatisfiedPatientCare">Dissatisfied with Patient Care</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="reasonForLama" id="unsatisfactoryTreatment" value="Unsatisfactory Treatment" checked={formData.reasonForLama === "Unsatisfactory Treatment"} onChange={handleChange} />
                                            <label className="form-check-label" htmlFor="unsatisfactoryTreatment">Unsatisfactory Treatment</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="reasonForLama" id="unsatisfactoryAdmin" value="Unsatisfactory Administrative Arrangements" checked={formData.reasonForLama === "Unsatisfactory Administrative Arrangements"} onChange={handleChange} />
                                            <label className="form-check-label" htmlFor="unsatisfactoryAdmin">Unsatisfactory Administrative Arrangements</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4 d-flex align-items-center">
                                        <div className="form-check me-2">
                                            <input className="form-check-input" type="radio" name="reasonForLama" id="otherReason" value="Other" checked={formData.reasonForLama === "Other"} onChange={handleChange} />
                                            <label className="form-check-label" htmlFor="otherReason">If any other reason please specify here</label>
                                        </div>
                                        {formData.reasonForLama === "Other" && (
                                            <input type="text" className="form-control" name="otherReason" value={formData.otherReason || ""} onChange={handleChange} placeholder="Specify" />
                                        )}
                                    </div>
                                </div>
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block my-4">
                                    Consultant / Shift In-Charge
                                </small>
                                <div className="row g-3">
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="consultantName" value={formData.consultantName || ""} onChange={handleChange} />
                                            <label>Name</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input type="text" className="form-control" name="diagnosis" value={formData.diagnosis || ""} onChange={handleChange} />
                                            <label>Diagnosis</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input type="date" className="form-control" name="date" value={formData.date || ""} onChange={handleChange} />
                                            <label>Date</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-floating form-floating-outline">
                                            <input type="time" className="form-control" name="time" value={formData.time || ""} onChange={handleChange} />
                                            <label>Time</label>
                                        </div>
                                    </div>
                                </div>
                                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block my-4">
                                    PRP Remarks
                                </small>
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <div className="form-floating form-floating-outline">
                                            <textarea className="form-control" name="prpRemarks" value={formData.prpRemarks || ""} onChange={handleChange} rows="4" />
                                            <label>PRP Remarks</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LamaForm;